import React from 'react'
import { Button, Dropdown } from 'antd'
import { DownOutlined, FileOutlined } from '@ant-design/icons'
import { useLazyDownloadSubmissionsSummaryQuery } from '../../../../../../store/apis/submission.api'
import fileDownload from 'js-file-download'
import { openNotificationWithIcon } from '../../../../../../utils/notification.helper'

const extensionsToDownload = ['csv', 'txt', 'json']

const SubmissionsSummaryModalFooter = ({ assignmentName, token }) => {
    const [downloadSubmissionsSummary, { isFetching: isDownloadingSubmissionsSummary }] =
        useLazyDownloadSubmissionsSummaryQuery()

    const handleExtensionClick = async extension => {
        const response = await downloadSubmissionsSummary({ token, type: extension })
        if ('data' in response) fileDownload(response.data, `${assignmentName}.${extension}`)
        else openNotificationWithIcon('error', response.error)
    }

    const exportMenuItems = extensionsToDownload.map(extension => ({
        key: extension,
        label: extension,
        onClick: () => handleExtensionClick(extension),
    }))

    return (
        <Dropdown
            trigger={['click']}
            autoFocus
            key='export'
            menu={{ items: exportMenuItems, triggerSubMenuAction: 'click' }}
            getPopupContainer={trigger => trigger.parentNode}
        >
            <Button type='primary' size='large' loading={isDownloadingSubmissionsSummary}>
                <FileOutlined />
                Export
                <DownOutlined />
            </Button>
        </Dropdown>
    )
}

export default SubmissionsSummaryModalFooter
